import "../styles.scss";

import { Icons } from "components";
import MicOffIcon from "../icons/MicOffIcon";
//Icons
import MicOnIcon from "../icons/MicOnIcon";
import React from "react";
import Strings from "utils/strings";
import { Tooltip } from "antd";
import VideoOffIcon from "../icons/VideoOffIcon";
import VideoOnIcon from "../icons/VideoOnIcon";
import { connect } from "react-redux";
import { setVideoSettings } from "store/actions";

export class MenuBar extends React.Component<any, any> {
	getLocalAudioTrack = () => {
		const { room } = this.props;
		let audioTrack = null;
		const firstAudioTrack = room.localParticipant?.audioTracks;
		if (typeof firstAudioTrack?.values === "function") {
			for (const elem of firstAudioTrack.values()) {
				audioTrack = elem?.track;
				break;
			}
		} else if (typeof firstAudioTrack === "object") {
			const firstAudioKey = Object.keys(room.localParticipant?.audioTracks)[0];
			audioTrack = room.localParticipant?.audioTracks?.[firstAudioKey];
		}

		return audioTrack;
	};

	getLocalVideoTrack = () => {
		const { room } = this.props;
		let videoTrack = null;
		const videoTracks = room.localParticipant?.videoTracks;
		if (typeof videoTracks?.values === "function") {
			for (const elem of videoTracks.values()) {
				videoTrack = elem?.track;
				break;
			}
		} else if (typeof videoTracks === "object") {
			const firstAudioKey = Object.keys(room.localParticipant?.videoTracks)[0];
			videoTrack = room.localParticipant?.videoTracks?.[firstAudioKey];
		}

		return videoTrack;
	};

	minimizeWindow() {
		const { videoSettings, dispatch, onExitFullScreen } = this.props;

		dispatch(setVideoSettings({ ...videoSettings, state: "minimized" }));
		document.body.classList.remove("InCallMaximized");

		if (document.fullscreenElement) {
			onExitFullScreen();
		}
	}

	maximizeWindow() {
		const { videoSettings, dispatch, onExitFullScreen } = this.props;

		dispatch(setVideoSettings({ ...videoSettings, state: "regular" }));
		document.body.classList.add("InCallMaximized");

		if (document.fullscreenElement) {
			onExitFullScreen();
		}
	}

	render() {
		const { room, bottom, isMinimized, onFullScreen, fullscreen, showMobileOverlay, onDisconnect } = this.props;
		const { mobile } = this.props;

		let audioTrack: any = this.getLocalAudioTrack();
		let videoTrack: any = this.getLocalVideoTrack();

		if (bottom) {
			return (
				<div className="MenuBar">
					<Tooltip
						title={audioTrack?.isEnabled ? Strings.video.mute : Strings.video.unmute}
						placement="top"
						trigger={showMobileOverlay ? "" : "hover"}
					>
						<div
							className="VideoIconContainer"
							onClick={() => {
								if (!audioTrack) return;
								if (audioTrack?.isEnabled && typeof audioTrack?.disable === "function")
									audioTrack?.disable();
								else if (typeof audioTrack?.enable === "function") audioTrack?.enable();
								this.forceUpdate();
							}}
						>
							<div className="MenuOption">
								{audioTrack?.isEnabled ? <MicOnIcon audioTrack={audioTrack} /> : <MicOffIcon />}
							</div>
						</div>
					</Tooltip>
					<div className="VideoDisconnectContainer">
						<Tooltip
							title={Strings.video.disconnect}
							placement="top"
							trigger={showMobileOverlay ? "" : "hover"}
						>
							<div
								className="VideoIconContainer __circle __disconnect"
								onClick={() => {
									if (typeof room?.disconnect === "function") {
										onDisconnect();
										room?.disconnect();
									}

									document.body.classList.remove("InCallMaximized");
								}}
							>
								<div className="MenuOption">
									<Icons.PhoneCall />
								</div>
							</div>
						</Tooltip>
					</div>
					<Tooltip
						title={videoTrack?.isEnabled ? Strings.video.disableVideo : Strings.video.enableVideo}
						placement="top"
						trigger={showMobileOverlay ? "" : "hover"}
					>
						<div
							className="VideoIconContainer"
							onClick={() => {
								if (!videoTrack) return;
								if (videoTrack?.isEnabled && typeof videoTrack?.disable === "function")
									videoTrack?.disable();
								else if (typeof videoTrack?.enable === "function") videoTrack?.enable();
								this.forceUpdate();
							}}
						>
							<div className="MenuOption">
								{videoTrack?.isEnabled ? <VideoOnIcon /> : <VideoOffIcon />}
							</div>
						</div>
					</Tooltip>
				</div>
			);
		}

		return (
			<div className="MenuBar">
				{isMinimized && (
					<Tooltip
						title={Strings.video.maximize}
						placement="bottomRight"
						trigger={showMobileOverlay ? "" : "hover"}
					>
						<div
							className="VideoIconContainer"
							onClick={() => {
								this.maximizeWindow();
							}}
						>
							<Icons.Maximize />
						</div>
					</Tooltip>
				)}
				{!isMinimized && !fullscreen && (
					<React.Fragment>
						<Tooltip
							title={Strings.video.minimize}
							placement="bottomRight"
							trigger={showMobileOverlay ? "" : "hover"}
						>
							<div
								className={`VideoIconContainer${mobile ? " __disabled" : ""}`}
								onClick={() => {
									if (!mobile) {
										this.minimizeWindow();
									}
								}}
							>
								<Icons.Minimize />
							</div>
						</Tooltip>
						<Tooltip
							title={Strings.video.fullscreen}
							placement="bottomRight"
							trigger={showMobileOverlay ? "" : "hover"}
						>
							<div className="VideoIconContainer" onClick={() => onFullScreen()}>
								<Icons.Maximize />
							</div>
						</Tooltip>
					</React.Fragment>
				)}
				{fullscreen && (
					<Tooltip
						title={Strings.video.exitFullscreen}
						placement="bottomRight"
						trigger={showMobileOverlay ? "" : "hover"}
					>
						<div className="VideoIconContainer" onClick={() => onFullScreen()}>
							<Icons.Maximize />
						</div>
					</Tooltip>
				)}
			</div>
		);
	}
}

const mapStateToProps = (state: any) => ({
	room: state.room,
	videoSettings: state.videoSettings
});

export default connect(mapStateToProps)(MenuBar);
